(function () {
    angular
        .module("app")
        .controller("MasterController", MasterController);

    MasterController.$inject = ["$scope"];

    function MasterController($scope) {

        window._masterController = $scope;
        $scope.title = "master controller";

    }
})();
